export default {"src":"/_next/static/media/call-logo.eaaab2fd.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};